import * as React from "react";

function ConectaZapWarningIcon(props) {
  return (
    <svg
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.25}
        y={0.318848}
        width={40}
        height={40}
        rx={20}
        fill="#FAB11E"
      />
      <mask
        id="a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={8}
        y={8}
        width={25}
        height={25}
      >
        <path fill="#D9D9D9" d="M8.25 8.31885H32.25V32.31885H8.25z" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M10.984 29.319a1 1 0 01-.865-1.501l9.266-16.004a1 1 0 011.73 0l9.266 16.004a1 1 0 01-.865 1.5H10.984zm2.152-2.751a.5.5 0 00.433.75H26.93a.5.5 0 00.433-.75l-6.682-11.505a.5.5 0 00-.864 0l-6.682 11.505zm7.114-.25c.283 0 .52-.095.712-.287a.967.967 0 00.288-.712.968.968 0 00-.288-.713.968.968 0 00-.712-.287.968.968 0 00-.712.287.968.968 0 00-.288.713c0 .283.096.52.288.712.191.192.429.288.712.288zm-1-3.8a.8.8 0 00.8.8h.4a.8.8 0 00.8-.8v-3.4a.8.8 0 00-.8-.8h-.4a.8.8 0 00-.8.8v3.4z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default ConectaZapWarningIcon;
